import clsx from "clsx";
import React from "react";

const FormGroup = ({ children, className, ...props }) => {
    return (
        <div className={`${clsx('tw-flex tw-flex-col tw-flex-1', className)}`}
            {...props}>
                {children}
        </div>
    );
}

export default FormGroup;
